export default __webpack_public_path__ + "static/slider4-26aa3e3e972a8e6220a034cb686570fa.jpg";